import { ApplicationRef, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { slideInAnimation } from './route-animations';
import { SwUpdate } from '@angular/service-worker';
import { concat, timer } from 'rxjs';
import { first } from 'rxjs/operators';
import { RestaurantService } from './services/restaurant.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [slideInAnimation],
})
export class AppComponent {
  loading$ = this.restaurant.loading$;
  unableToLoad$ = this.restaurant.unableToLoad$;

  constructor(appRef: ApplicationRef, updates: SwUpdate, private title: Title, private restaurant: RestaurantService) {
    if (updates.isEnabled) {
      updates.available.subscribe((event) => {
        console.log('current version is', event.current);
        console.log('available version is', event.available);
      });
      updates.activated.subscribe((event) => {
        console.log('old version was', event.previous);
        console.log('new version is', event.current);
        updates.activateUpdate().then(() => document.location.reload()); // TODO
      });
      const appIsStable$ = appRef.isStable.pipe(first((isStable) => isStable === true));
      const everyFiveMinutes = timer(0, 5 * 60 * 1000);
      const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everyFiveMinutes);

      everySixHoursOnceAppIsStable$.subscribe(() => updates.checkForUpdate());
    }
    this.restaurant.observe().subscribe((restaurant) => {
      if (restaurant) {
        this.title.setTitle(`Fair Pizza - ${restaurant.info.name}`);
      } else {
        this.title.setTitle(`Fair Pizza`);
      }
    });
  }

  retry() {
    this.restaurant.retryGet();
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }
}
